import { useSelector } from 'react-redux';
import { getSearchFilteredDefaultModules, getIsPaymentModuleVisible } from 'EmailEditorUI/redux/selectors/ModuleSelectors';
import RenderModules from 'LayoutBuilderUI/components/panels/sidebar/reusableHelpers/RenderModules';
import PaymentModule from 'LayoutBuilderUI/components/panels/sidebar/reusableHelpers/PaymentModuleTile';
import { jsx as _jsx } from "react/jsx-runtime";
const SearchFilteredModules = () => {
  const searchFilteredModules = useSelector(getSearchFilteredDefaultModules);
  const isPaymentModuleVisible = useSelector(getIsPaymentModuleVisible);
  if (!isPaymentModuleVisible && searchFilteredModules.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx(RenderModules, {
    modules: searchFilteredModules,
    isPaymentModuleVisible: isPaymentModuleVisible,
    withStoringInRecentlyUsed: true,
    children: /*#__PURE__*/_jsx(PaymentModule, {})
  });
};
export default SearchFilteredModules;